





















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { projectStateConfig } from '@config';
import { ProjectService } from '@store/service/ProjectService';
import { StringHelper } from '@fruitpackage/helpers';
import StoreDispatcher from '@service/StoreDispatcher';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            buttonRoute: null,
            buttonClass: null,
            buttonText: null,
        }
    },

    created() {
        this.stateConfig = projectStateConfig[this.project.state];
        this.projectService = new ProjectService(this.$store);
        const route = this.stateConfig.route;
        this.setButton();
    },

    computed: {
        cAmount() {
            return StringHelper.formatNumber(this.project.amount);
        }
    },

    methods: {
        deleteProject() {
            var deleteConfirm = confirm(`Weet u zeker dat u project ${this.project.title} wilt verwijderen?`);
            if (!deleteConfirm) return;

            this.projectService.deleteProject().then(response => {
                this.$root.$emit('root::projects::fetch');
            });
        },

        setButton() {
            this.buttonClass = this.stateConfig.buttonClass;
            this.buttonText =  this.stateConfig.buttonText;

            const route = this.stateConfig.route;

            if (route !== 'continue') {
                this.buttonRoute = route.replace('[projectId]', this.project.id);
                return;
            }

            // Organisation
            if (!this.organisation.community) {
                if (!this.organisation.kvk) {
                    this.buttonRoute = `/apply/${ this.project.id }/applicant/kvk`;
                    return;
                }
                if (!this.organisation.file_types.includes('statuten') && !this.organisation.file_types.includes('jaarrekening')) {
                    this.buttonRoute = `/apply/${ this.project.id }/applicant/tekenbevoegd-vereist`;
                    return;
                }
            }

            // Community
            if (this.organisation.community) {

            }

            // Project
            if (!this.project.starts_at) {
                this.buttonRoute = `/apply/${ this.project.id }/project/aanvang`;
                return;
            }

            if (!this.project.file_types.includes('projectplan')) {
                this.buttonRoute = `/apply/${ this.project.id }/project/projectplan`;
                return;
            }

            if (!this.project.file_types.includes('begroting-dekking')) {
                this.buttonRoute = `/apply/${ this.project.id }/project/begroting`;
                return;
            }

            if (!this.project.file_types.includes('offerte')) {
                this.buttonRoute = `/apply/${ this.project.id }/project/offertes`;
                return;
            }

            if (!this.project.amount) {
                this.buttonRoute = `/apply/${ this.project.id }/project/bedrag`;
                return;
            }

            this.buttonClass = 'btn-ghost--gray';
            this.buttonText = 'Open';
            this.buttonRoute = `/apply/${ this.project.id }/confirmation/bevestig`;
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ProjectItem extends Vue {
    @Prop() project!: object
    @Prop() organisation!: object
};

